import { render } from "./AdsBrokerageConfigurationCreating.vue?vue&type=template&id=af33ba9e&scoped=true&ts=true"
import script from "./AdsBrokerageConfigurationCreating.vue?vue&type=script&lang=ts"
export * from "./AdsBrokerageConfigurationCreating.vue?vue&type=script&lang=ts"

import "./AdsBrokerageConfigurationCreating.vue?vue&type=style&index=0&id=af33ba9e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af33ba9e"]])

export default __exports__